import { Card, Checkbox, ConfigProvider, Divider, Flex, Space, Tooltip, Typography } from "antd";
import { isMobile } from "react-device-detect";
import React from "react";

export default function Characteristics({
  characteristics,
  handleClickCharacteristics,
  characteristicsSelected,
}) {
  if (characteristics.length === 0) {
    return <div>Sem caracteristicas para mostrar...</div>
  }

  const styles = {
    borderWidth: 3,
    borderColor: '#ffcc00',
    checkedColor: '#ffcc00',
    iconColor: '#ffffff',
    checkedIconColor: '#ffcc00',
  };
  return (
    characteristics &&
    characteristics.map((item) => {
      return (
        <Flex vertical>
          <Flex align='center' justify='space-between' style={{
            width: isMobile ? "100%" : "90%",
            minWidth: isMobile ? "100%" : "95%",
            maxWidth: isMobile ? "100%" : "80%",
            height: isMobile ? "100%" : "90%",
            minHeight: "100px",
            alignSelf: "center",
            justifySelf: "center",
            borderRadius: isMobile ? "12px" : "24px",
            boxShadow: isMobile ? "1px 2px 9px rgba(0, 0, 0, 0.245)" : "1px 2px 9px rgba(0, 0, 0, 0.245)",
            padding: "2rem",
            marginBottom: "1rem",
            justifyContent: "space-between",
          }}>
            <img
              src={item.icon}
              width={!isMobile ? "64" : "32"}
              height={!isMobile ? "64" : "32"}
              style={{
                borderRadius: isMobile ? "12px" : "24px",
                cursor: "pointer",
                transition: "0.3s all ease-in-out",
                opacity: characteristicsSelected.includes(item._id.$oid) ? "1" : "0.5",
              }}
            />
            <Tooltip title={item.name} placement="right">
              <Typography.Title level={isMobile ? 5 : 4} >
                {item.name}
              </Typography.Title>
            </Tooltip>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "orange",
                },
              }}
            >
              <Checkbox
                style={styles}
                checked={characteristicsSelected.includes(item._id.$oid)}
                onChange={() => handleClickCharacteristics(item._id.$oid)}
              />
            </ConfigProvider>

          </Flex>
          {!isMobile && <Divider type="horizontal" style={{ marginLeft: "1rem", marginRight: "1rem" }} />}
        </Flex>
      );
    })
  );
}

